"use client";

// src/ext/overlay-provider.tsx
import React, { useContext, useMemo, useState } from "react";
import { jsx } from "react/jsx-runtime";
var Context = React.createContext(null);
function ModalProvider(props) {
  let { children } = props;
  let parent = useContext(Context);
  let [modalCount, setModalCount] = useState(0);
  let context = useMemo(
    () => ({
      parent,
      modalCount,
      addModal() {
        setModalCount((count) => count + 1);
        if (parent) {
          parent.addModal();
        }
      },
      removeModal() {
        setModalCount((count) => count - 1);
        if (parent) {
          parent.removeModal();
        }
      }
    }),
    [parent, modalCount]
  );
  return /* @__PURE__ */ jsx(Context.Provider, { value: context, children });
}
function useModalProvider() {
  let context = useContext(Context);
  return {
    modalProviderProps: {
      "aria-hidden": context && context.modalCount > 0 ? true : void 0
    }
  };
}
function OverlayContainerDOM(props) {
  let { modalProviderProps } = useModalProvider();
  return /* @__PURE__ */ jsx("div", { "data-overlay-container": true, ...props, ...modalProviderProps });
}
function OverlayProvider(props) {
  return /* @__PURE__ */ jsx(ModalProvider, { children: /* @__PURE__ */ jsx(OverlayContainerDOM, { ...props }) });
}

export {
  OverlayProvider
};
